export const JwtLocalStorageKey = {
  Default: 'cockpit::api-token',
  Client: 'cockpit-client::api-token',
  Funder: 'cockpit-funder::api-token',
} as const;
